/* eslint-disable consistent-return */
import Actions from 'actions/Actions';
import mfaVerificationApi from 'services/api/authentication/mfaVerification';

/**
 * Validates MFA (phone or email)
 * @param {string} phone - Phone number to validate
 * @param {string} email - User's email
 * @param {string} mfaMode - 'phone' or 'email'
 * @returns {Promise} - Promise that resolves with response or rejects with error
 */
function validateMFAEmailPhone(phone, email, mfaMode) {
    return async dispatch => {
        dispatch(Actions.showInterstice(true));

        try {
            const response = await mfaVerificationApi.validateMFAEmailPhone(phone, email, mfaMode);

            return response;
        } catch (error) {
            return Promise.reject(error);
        } finally {
            dispatch(Actions.showInterstice(false));
        }
    };
}

/**
 * Validates MFA (phone or email)
 * @param {string} email - User's email
 * @param {string} otpCode - OTP Code to validate
 * @param {string} mfaMode - 'phone' or 'email'
 * @param {string} keepSignedIn - 'true' or 'false'
 * @returns {Promise} - Promise that resolves with response or rejects with error
 */
function validateOTP(email, otpCode, mfaMode, keepSignedIn) {
    return async dispatch => {
        dispatch(Actions.showInterstice(true));

        try {
            const response = await mfaVerificationApi.mfaVerifyOTP(email, otpCode, mfaMode, keepSignedIn);

            return response;
        } catch (error) {
            return Promise.reject(error);
        } finally {
            dispatch(Actions.showInterstice(false));
        }
    };
}

export default {
    validateMFAEmailPhone,
    validateOTP
};
